export default __webpack_public_path__ + "static/media/kit_svg7.34dbe51d.svg";